import React, {Component, ReactNode} from "react"
import {Query, QueryProps} from "react-apollo"

import DefaultLoader from "./Loading/Loader"
import DefaultError from "./Loading/Error"
import {ApolloState} from "./apolloStateInterface"

export interface QueryComponentProps<TData = any, TVariables = any> extends Omit<QueryProps<TData, TVariables>, "children"> {
  children: (data: ApolloState<TData, TVariables>) => React.ReactNode,
  Error?: ReactNode,
  Loader?: ReactNode,
  useLoader?: boolean,
  useError?: boolean
}

export default class LoadingQuery<TData = any, TVariables = any> extends Component<QueryComponentProps<TData, TVariables>> {
  static defaultProps = {
    Error: DefaultError,
    Loader: DefaultLoader,
    useLoader: true,
    useError: true,
    errorHandler: null
  }

  render() {
    const {Loader = DefaultLoader, Error = DefaultError, useLoader, useError} = this.props

    return (
      <Query {...this.props}>
        {(apollo) => {
          const isLoading = apollo.networkStatus === 4 || apollo.loading
          if (isLoading && useLoader) return <Loader />
          if (apollo.error && useError) return <Error apollo={apollo} />

          return this.props.children(apollo)
        }}
      </Query>
    )
  }
}
